import { FormikHelpers } from 'formik'
import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppContext } from '../../../app/AppContext'
import { updateUserSettings } from '../../settings/api'
import { setUserSettings } from '../db/userProfile'
import { UserSettings } from '../types'
import { ProfileEditForm, ProfileFormFields } from './ProfileEditForm'

export function ProfileEditSection({ data }: { data: UserSettings }) {
  const navigate = useNavigate()
  const { addAlertErrorMessage } = useContext(AppContext)

  const onSubmit = async (
    values: ProfileFormFields,
    { resetForm }: FormikHelpers<ProfileFormFields>
  ) => {
    try {
      const response = await updateUserSettings(values)
      void setUserSettings(response)

      resetForm({ values })
      navigate(-1)
    } catch (error: any) {
      addAlertErrorMessage(error.message)
    }
  }

  return (
    <ProfileEditForm
      initialValues={{
        timeTrackingDefaultProjectCostCenterSelectionView:
          data.timeTrackingDefaultProjectCostCenterSelectionView,
        articleDialogDefaultSelectionView:
          data.articleDialogDefaultSelectionView,
      }}
      onSubmit={onSubmit}
    />
  )
}
